/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useEffect } from 'react';
import { isUndefined, toNumber } from 'lodash-es';
import { sendSentryError } from '../utils/sentry.ts';
import {
  useUpdatePortfolioPopupWasShownQuery,
  UpdatePortfolioPopupWasShownDocument,
  type UpdatePortfolioPopupWasShownQuery,
} from '../apollo';
import { useExchange, useModals } from '../providers';

export const useManageUpdatePortfolioPopupShow = () => {
  const { data, client } = useUpdatePortfolioPopupWasShownQuery();
  const { exchange } = useExchange();
  const { dispatch } = useModals();

  useEffect(() => {
    if (exchange?.sentToRebalancing || !exchange?.portfolioOutdated) return;

    if (
      isUndefined(data?.updatePortfolioPopupWasShown) ||
      data.updatePortfolioPopupWasShown
    ) {
      return;
    }

    if (!(exchange?.exchangeID && exchange?.exchangeCode)) {
      sendSentryError(
        new Error(
          'There is no exchangeID and/or exchangeCode to open newRebalance popup'
        )
      );
      return;
    }

    dispatch({
      type: 'setModalContent',
      payload: {
        name: 'newRebalance',
        data: {
          exchangeId: toNumber(exchange.exchangeID),
          exchangeCode: exchange.exchangeCode,
        },
      },
    });

    client.writeQuery<UpdatePortfolioPopupWasShownQuery>({
      query: UpdatePortfolioPopupWasShownDocument,
      data: {
        updatePortfolioPopupWasShown: true,
      },
    });
  }, [
    data?.updatePortfolioPopupWasShown,
    exchange?.exchangeID,
    exchange?.exchangeCode,
    exchange?.sentToRebalancing,
    exchange?.portfolioOutdated,
    client,
    dispatch,
  ]);
};
